<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
<!-- Breadcrumb y ayuda -->    
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/atencion">Atenciones</router-link> >
            <router-link :to="'/atencionform/' + p_idAtencion">Atención {{ p_idAtencion }}</router-link> 
            > Interconsultas
          </div>
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;"
            @click="showModalHelp = true">help
          </span>
        </div>
      </div>
    </div>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Especialidad</th>
          <th scope="col">Médico</th>
          <th scope="col">Motivo</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="interconsulta in datosPaginados" :key="interconsulta.idInterconsulta">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(interconsulta.idInterconsulta)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(interconsulta.idInterconsulta)" title="Editar">edit_square</i></td>
          <td>{{interconsulta.especialidad}}</td>
          <td>{{interconsulta.medico}}</td>
          <td>{{interconsulta.motivo}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteInterconsulta(interconsulta.idInterconsulta)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPaginaTodos(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idInterconsulta" class="form-label">IdInterconsulta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idInterconsulta" name="idInterconsulta" v-model="datoInterconsulta.idInterconsulta" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Atencion -->
<!--
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label"> Atencion</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAtencion" name="idAtencion" v-model="datoInterconsulta.idAtencion">
                      <option v-for="atencion in atencions" :value="atencion.idAtencion" :key="atencion.idAtencion">
                        {{ atencion.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
-->            
<!-- Botón Lista de Valores  Atencion -->
<!-- Botón Lista de Valores  Especialidad -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idEspecialidad" class="form-label"> Especialidad</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idEspecialidad" name="idEspecialidad" v-model="datoInterconsulta.idEspecialidad" @change="fetchMedicos">
                      <option v-for="especialidad in especialidads" :value="especialidad.idEspecialidad" :key="especialidad.idEspecialidad">
                        {{ especialidad.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Especialidad -->
<!-- Botón Lista de Valores  Medico -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idMedico" class="form-label"> Medico</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idMedico" name="idMedico" v-model="datoInterconsulta.idMedico">
                      <option v-for="medico in medicos" :value="medico.idMedico" :key="medico.idMedico">
                        {{ medico.nombreCompleto }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Medico -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="motivo" class="form-label">Motivo</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="motivo" name="motivo" v-model="datoInterconsulta.motivo" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="cuadro" class="form-label">Cuadro</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="cuadro" name="cuadro" v-model="datoInterconsulta.cuadro" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarInterconsulta" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditInterconsulta" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      interconsultas : [],
      datoInterconsulta : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      atencions: [],
      especialidads: [],
      medicos: [],
      p_idAtencion: 0,
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.p_idMedico = this.$route.params.p_imedico
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
//    this.fetchAtencions()
    this.fetchEspecialidads()
//    this.fetchMedicos()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.interconsultas.length / this.elementosPorPagina)
    },
/*    
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwinterconsultas/nombre/'+this.nombreBusqueda).then(response=>{
          this.interconsultas=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.interconsultas.slice(ini,fin);
        });
      }
    },
*/
    getDataPaginaTodos(noPagina){
      api.get('/vwinterconsultas/idatencion/'+this.p_idAtencion).then(response=>{
      this.interconsultas=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.interconsultas.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idAtencion'
        ,'idEspecialidad'
        ,'idMedico'
        ,'motivo'
        ,'cuadro'
      ];
      const requiredFieldsText = [
        'idAtencion'
        ,'idEspecialidad'
        ,'idMedico'
        ,'motivo'
        ,'cuadro'
      ];
      return validarForm(this.datoInterconsulta, requiredFields, requiredFieldsText);
    },
    async guardarInterconsulta(){
      if(this.validarForm() === 1){
        try {
          await api.post('/interconsultas', this.datoInterconsulta)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Interconsulta creada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditInterconsulta(){
      if(this.validarForm() === 1){
        try {
          await api.post('/interconsultas', this.datoInterconsulta)
          $('#ventanaModal').modal('hide');
          this.getDataPaginaTodos(this.paginaActual);
          swal("Correcto!", "Interconsulta creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoInterconsulta={}
      this.titulo   = 'Crear Atención: Interconsulta'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idInterconsulta){
      this.modalWindow = true
      if(idInterconsulta != null){    
           api.get('/vwinterconsultas/'+idInterconsulta).then(resp=>{
          this.datoInterconsulta = resp.data;
          this.fetchMedicos();
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Atención: Interconsulta'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idInterconsulta){
      if(idInterconsulta != null){
        this.$router.push('/interconsultaform/'+idInterconsulta)
      }
    },
    async deleteInterconsulta (idInterconsulta) {
      try{
        await api.delete('/interconsultas/'+idInterconsulta)
          this.getDataPaginaTodos(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
/*    
    fetchAtencions() {
      fetch('http://localhost:8080/api/v1/atencions')
        .then(response => response.json())
        .then(data => {
          this.atencions = data;
        })
        .catch(error => {
          console.error('Error fetching atencions:', error);
        });
    },
*/    
    fetchEspecialidads() {
      fetch('http://localhost:8080/api/v1/especialidads')
        .then(response => response.json())
        .then(data => {
          this.especialidads = data;
        })
        .catch(error => {
          console.error('Error fetching especialidads:', error);
        });
    },
    fetchMedicos() {
      fetch(`/vwmedicos/idempresa-idespecialidad?idempresa=${window.sessionStorage.getItem("idEmpresa")}&idespecialidad=${this.datoInterconsulta.idEspecialidad}`)
        .then(response => response.json())
        .then(data => {
          this.medicos = data;
        })
        .catch(error => {
          console.error('Error fetching medicos:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
